import React from "react";
import Camera from './assets/camera-menu.svg';
import Internet from './assets/internet-icon-menu.svg';
import Phone from './assets/phone-icon-menu.svg';
import Wifi from './assets/wifi-menu.svg';
import './Menu.css';

export default function Menu ()
{
    return (
        <div className="menu">
            <ul className="menu-list">
                <li className="first">...</li>
                <li className="menu-list-item"><a className="menu-link" href="#internet"><img width={20} height={20} src={Internet}></img><p className="menu-list-desc">Интернет</p></a></li>
                <li className="menu-list-item"><a className="menu-link" href="#wifi"><img width={20} height={20} src={Wifi}></img><p className="menu-list-desc">Бесшовный WI-FI</p></a></li>
                <li className="menu-list-item"><a className="menu-link" href="#phone"><img width={20} height={20} src={Phone}></img><p className="menu-list-desc">Телефония</p></a></li>
                <li className="menu-list-item"><a className="menu-link" href="#video"><img width={20} height={20} src={Camera}></img><p className="menu-list-desc">Видеонаблюдение</p></a></li>
            </ul>
        </div>
    )
}